import React from "react";
import ClientFormHeader from "./ClientFormHeader";
import ClientForm from "./ClientForm";

const MainClientForm = () => {
  return (
    <div>
      <ClientFormHeader />
      <ClientForm />
    </div>
  );
};

export default MainClientForm;
